import { validationIsEqual } from '../status';
import {
    validateDateOfBirth,
    validateEmail,
    validateName,
    validateContactNumber,
    validateSingleSelection,
    validateNumber,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericString,
    validateKraPinNumber,
    validateKeCarRegNumber,
    validateNumericString,
    validateAlphaString,
    validatePassportNumber,
    validateDate,
} from '@om/validation';
import {
    GENDER_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    LAST_NAME_SET_VALUE,
    NATIONALITY_SET_VALUE,
    PASSPORT_NUMBER_SET_VALUE,
    PASSPORT_ORIGIN_SET_VALUE,
    PASSPORT_EXPIRY_SET_VALUE,
    DOB_SET_VALUE,
    OCCUPATION_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    EMAIL_SET_VALUE,
    POSTAL_ADDRESS_SET_VALUE,
    MARITAL_STATUS_SET_VALUE,
    RESIDENTIAL_STATUS_SET_VALUE,
    TOWN_SET_VALUE,
    ADDRESS_SET_VALUE,
    setGenderValid,
    setNationalityValid,
    setPassportNumberValid,
    setPassportOriginValid,
    setPassportExpiryValid,
    setOccupationValid,
    setIdNumberValid,
    setPostalAddressValid,
    setFirstNameValid,
    setLastNameValid,
    setEmailValid,
    setPhoneNumberValid,
    setDOBValid,
    setTinNumberValid,
    setMaritalStatusValid,
    setResidentialStatusValid,
    setTownValid,
    setAddressValid,
} from '../../../actions/naMotorInsurance/personalDetails';
import { validateIdNumber } from '@om/validation/src/validators/nam-id-validator';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

let prevValidationAction = null;

export const personalDetailsValidation = (store, next, action) => {
    /*
function validateUgandanPhoneNumber(phoneNumber) {
    const regex = /^(07|03|04)\d{8}$/;

    const isValid = regex.test(phoneNumber);

    return isValid;
}
*/

    const validationAction = (() => {
        let error;
        let today = new Date();
        let validTodayDate = today.toLocaleDateString('en-NG').split('/').join('/');
        switch (action.type) {
            case GENDER_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Gender',
                });
                return setGenderValid(error);

            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'First Name',
                });
                return setFirstNameValid(error);

            case LAST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Last Name',
                });
                return setLastNameValid(error);

            case NATIONALITY_SET_VALUE:
                error = validateSingleSelection(action.value, {});
                return setNationalityValid(error);

            case OCCUPATION_SET_VALUE:
                error = validateSingleSelection(action.value, {});
                return setOccupationValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateIdNumber(action.value);
                return setIdNumberValid(error);

            case TIN_NUMBER_SET_VALUE:
                error =
                    gatsbyStack === 'ug' || gatsbyStack === 'na'
                        ? validateNumericString(action.value, { min: 10, max: 10 })
                        : validateKraPinNumber(action.value);
                return setTinNumberValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case POSTAL_ADDRESS_SET_VALUE:
                error = validateAlphaNumericString(action.value);
                return setPostalAddressValid(error);

            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, { min: 15, max: 85 });
                return setDOBValid(error);

            case MARITAL_STATUS_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Marital Status',
                });
                return setMaritalStatusValid(error);

            case RESIDENTIAL_STATUS_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Residential Status',
                });
                return setResidentialStatusValid(error);

            case TOWN_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Town',
                });
                return setTownValid(error);

            case ADDRESS_SET_VALUE:
                error = validateAlphaString(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Address',
                });
                return setAddressValid(error);

            case PASSPORT_NUMBER_SET_VALUE:
                error = validatePassportNumber(action.value, {
                    subject: 'Passport number',
                });

                return setPassportNumberValid(error);

            case PASSPORT_EXPIRY_SET_VALUE:
                error = validateDate(action.value, {
                    subject: 'Passport expiry date',
                    min: validTodayDate,
                });

                return setPassportExpiryValid(error);

            case PASSPORT_ORIGIN_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Passport origin',
                });

                return setPassportOriginValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
